<script lang="ts">
  const { children } = $props()
</script>

<div class="context-menu-container">
  {@render children?.()}
</div>
